import { useContext } from "react";
import { ProductContext } from "../context/ProductContext";

export function useProductData() {
  return useContext(ProductContext);
}
